const API_BASE_URL = process.env.NODE_ENV === "production" ? "/api" : "http://127.0.0.1:8001";

export const authFetch = async (url, options = {}) => {
  const token = localStorage.getItem("token");

  return fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`,
    },
  });
};

export default API_BASE_URL;